import React, {Component} from "react";
import {SettlementService} from "../../../service/operation/settlement/SettlemetService";
import {Builder} from "../../../utils/lists/ListProcessor";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {numberWithCommaDataTableTemplate} from "../../../utils/formatters/Numbers";
import {Button} from "primereact/button";
import {Growl} from "primereact/growl";
import Settlement from "./SettlementView";

export default class SettlementContainer extends Component {
    constructor(props) {
        super(props);

        this.settlementService = new SettlementService();

        this.loading = this.loading.bind(this);
        this.getSettlement = this.getSettlement.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.handleSelectedRow = this.handleSelectedRow.bind(this);
        this.saveFilters = this.saveFilters.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.settlementTemplate = this.settlementTemplate.bind(this);


        this.state = {
            isLoading: true,
            settlementList: [],
            loanIdFilter: '',
            catFlowFilter: [],
            expanded: false,
        };

        this.getSettlement();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    getSettlement() {
        this.loading(true);
        this.settlementService.getSettlement(
            this.state.loanIdFilter,
            this.state.catFlowFilter.id
        ).then(response => {
            let builder = new Builder();
            builder.groupList(response, 'idFolioPrest');

            this.setState({
                settlementList: builder.mapObjects,
                expandedRows: builder.mapObjects,
            });
            this.loading(false);
        });
    }

    handleToggle = (event) => {
        this.setState(
            {
                expandedRows: event.data,
            })
    };

    handleSelectedRow = (event) => {
        this.setState(
            {
                selectedPosition: event.value,
            })
    };

    resendGss = (rowData) => {
        this.settlementService.resendGss(rowData).then(response => {
            if (response.error !== '') {
                this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
            } else {
                this.getSettlement();
                this.growl.show({
                    severity: 'info',
                    summary: 'Atención.',
                    detail: 'Se ha enviado la instucción con éxito'
                });
            }
        });
    }

    resendTrustInstruction = (rowData) => {
        this.settlementService.resendTrustInstruction(rowData).then(response => {
            if (response.error !== '') {
                this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
            } else {
                this.getSettlement();
                this.growl.show({
                    severity: 'info',
                    summary: 'Atención.',
                    detail: 'Se ha enviado la instrucción con éxito'
                });
            }
        });
    }

    settlementGss = (rowData) => {
        this.settlementService.settlementGss(rowData).then(response => {
            if (response.error !== '') {
                this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
            } else {
                this.getSettlement();
                this.growl.show({
                    severity: 'info',
                    summary: 'Atención.',
                    detail: 'Se ha liquidado la instrucción con éxito'
                });
            }
        });
    }

    settlementTemplate(rowData) {
        if (localStorage.getItem('institution') === 'Interno') {
            if (rowData['sistema'] === 'Custodia' && rowData['descripcionErr'].includes("Error")) {
                return (<Button type="button" label="Enviar" style={{marginRight: '3em'}}
                                onClick={() => {
                                    if (rowData['sistema'] === 'Custodia') {
                                        this.resendGss(rowData)
                                    } else {
                                        this.resendTrustInstruction(rowData)
                                    }
                                }}
                />);
            } else {
                if (rowData['sistema'] === 'Custodia' && rowData['folioInstruccion'] * 1 > 0 && !rowData['descripcionErr'].includes("LIQUIDADA")) {
                    return (<Button type="button" label="Liquidar" style={{marginRight: '3em'}}
                                    onClick={() =>
                                        this.settlementGss(rowData)}
                    />);
                }
            }
        }
    }

    rowExpansionTemplate(data) {
        const itemsInstitution = data.items;
        return (
            <
                div
                className="p-grid p-fluid"
                style={
                    {
                        padding: '1em'
                    }
                }>
                <
                    DataTable
                    value={itemsInstitution}
                    responsive={true}
                    selectionMode="single"
                    onSelectionChange={this.handleSelectedRow.bind(this)}
                    resizableColumns={true}
                    columnResizeMode={"fit"}>

                    < Column
                        field="folioInstruccion"
                        header="Folio Instrucción"
                        style={
                            {
                                textAlign: 'left'
                            }
                        }
                        sortable={true}
                    />
                    <Column field="sistema" header="Sistema" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="typeSettlement" header="Tipo" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="flujo" header="Flujo" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="emisora" header="Emisora" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="cantidad" header="Títulos" body={numberWithCommaDataTableTemplate}
                            style={{textAlign: 'right'}} sortable={true}/>
                    <Column field="institucionOrigen" header="Origen" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="institucionDestino" header="Destino" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column field="descripcionErr" header="Estatus" style={{textAlign: 'left'}}
                            sortable={true}/>
                    <Column header="Acciones"
                            body={this.settlementTemplate}
                            style={{textAlign: 'center', width: '8em'}}/>
                </DataTable>
            </div>
        );
    }

    saveFilters(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    clearFilters() {
        this.setState({
            loanIdFilter: '',
            catFlowFilter: [],
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <Settlement
            isLoading={this.state.isLoading}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            settlementList={this.state.settlementList}
            getSettlement={this.getSettlement}
            handleToggle={this.handleToggle}
            rowExpansionTemplate={this.rowExpansionTemplate}
            expandedRows={this.state.expandedRows}
            handleSelectedRow={this.handleSelectedRow}
            saveFilters={this.saveFilters}
            loanIdFilter={this.state.loanIdFilter}
            catFlowFilter={this.state.catFlowFilter}
            clearFilters={this.clearFilters}
        />

    }
};